import { Provider } from '@angular/core';
import { ANALYTICS_SCRIPTS, ANALYTICS_STRATEGIES } from '../../analytics.tokens';
import { YandexMetrikaStrategy } from './yandex-metrika.strategy';
import { YANDEX_METRIKA_ID } from './yandex-metrika.tokens';

export function provideYandexMetrika(id?: string): Provider[] {
  if (id == null) return [];

  return [
    {
      provide: YANDEX_METRIKA_ID,
      useValue: id
    },
    YandexMetrikaStrategy,
    {
      provide: ANALYTICS_STRATEGIES,
      useExisting: YandexMetrikaStrategy,
      multi: true
    },
    {
      provide: ANALYTICS_SCRIPTS,
      multi: true,
      useFactory: () => {
        if (typeof window === 'undefined') return;

        const script = document.createElement('script');
        script.type = 'text/javascript';

        script.text = `
          (function(m,e,t,r,i,k,a){
              m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
              m[i].l=1*new Date();
              for (var j = 0; j < document.scripts.length; j++) {
                if (document.scripts[j].src === r) { return; }
              }
              k=e.createElement(t),
              a=e.getElementsByTagName(t)[0],
              k.async=1,
              k.src=r,
              a.parentNode.insertBefore(k,a)
          })(window, document,'script','https://mc.yandex.ru/metrika/tag.js?id=${id}', 'ym');

          ym(${id}, 'init', {
            ssr:true,
            webvisor:true,
            clickmap:true,
            ecommerce:"dataLayer",
            referrer: document.referrer,
            url: location.href,
            accurateTrackBounce:true,
            trackLinks:true
          });
        `;

        document.head.appendChild(script);

        const noscript = document.createElement('noscript');
        noscript.innerHTML = `
          <div>
            <img src="https://mc.yandex.ru/watch/${id}"
                 style="position:absolute; left:-9999px;" alt="" />
          </div>
        `;
        document.body.appendChild(noscript);
      }
    }
  ];
}
